var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartcontainer w-100 elevation-4",attrs:{"dir":"ltr"}},[_c('apexchart',{attrs:{"type":"rangeBar","options":_vm.chartOptions,"series":_vm.series,"height":300,"width":_vm.chartWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }